<template>
    <div>

        <div class="row" id="addPriceListform">

            <div class="col-md-4 mt-2 col-12">
                <small class="">نام</small>
                <input v-model="newRow.Name" type="text" class="form-control required">
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">قیمت</small>
                <input v-model="newRow.Price" type="text" class="form-control InputText 3ragham" id="price"
                    @keyup="newRow.Price = $PutCommatoInput_New($event);" @keypress="$ValidNumber($event, 15)">
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">حداقل قیمت</small>
                <input v-model="newRow.MinPrice" type="text" class="form-control InputText 3ragham"
                    @keyup="newRow.MinPrice = $PutCommatoInput_New($event);" @keypress="$ValidNumber($event, 15)">
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">حداکثر قیمت</small>
                <input v-model="newRow.MaxPrice" type="text" class="form-control InputText 3ragham"
                    @keyup="newRow.MaxPrice = $PutCommatoInput_New($event);" @keypress="$ValidNumber($event, 15)">
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">فرمول</small>
                <input v-model="newRow.Func" type="text" class="form-control" dir="ltr">
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">اصلی</small>
                <div class="form-control ">
                    <input v-model="newRow.Main" type="checkbox" class="form-control form-control-sm checkbox" />
                </div>
            </div>

            <div class="col-md-4 mt-2  col-12">
                <small class="">قیمت ثابت</small>
                <div class="form-control">
                    <input v-model="newRow.FixPrice" type="checkbox" class="form-control form-control-sm checkbox" />
                </div>
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">آرشیو</small>
                <div class="form-control ">
                    <input v-model="newRow.IsArchive" type="checkbox" class="form-control form-control-sm checkbox" />
                </div>
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">تاریخ اتمام</small>
                <date-picker input-class="required form-control" color="dimgray" type="datetime"
                    v-model="newRow.ExpireTime" :editable="true" placeholder="تاریخ اتمام"></date-picker>
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">محصول</small>

                <SearchableCombo :edit="false" :grp="0" :code="null" :rownumintable="1"
                    @ResultCombo="GetResulTblProductsId" :action="'TblCrmCombo/GetProduct'" :method="'POST'"
                    :idinput="'TblProductsId'" :keyItem="'TblProductsId'" :disabled="false" :ClassProps="'required'">
                </SearchableCombo>
            </div>

            <div class="col-md-4 mt-2 col-12">
                <small class="">اختیاری</small>
                <div class="form-control">
                    <input v-model="newRow.IsOptional" type="checkbox" class="form-control form-control-sm checkbox" />
                </div>
            </div>
            <div class="d-flex justify-content-center col-12 ">
                <button class=" btn btn-success col-md-3 col-6" @click="submit()">
                    ثبت
                </button>
            </div>
        </div>

    </div>
</template>


<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import datePicker from "vue-persian-datetime-picker"

export default {
    components: { SearchableCombo, datePicker },

    data() {
        return {
            newRow: {}
        }
    },

    methods: {
        submit() {

            this.$ValidForm('addPriceListform')

            if(!this.vlidForm()){
                return
            }

            let price = document.getElementById('price')
            if(this.newRow.FixPrice || this.newRow.Main){
                price.classList.add('required')
            }else{
                price.classList.remove('required')
            }


            if (this.$ValidForm('addPriceListform')) {

                if (this.newRow.MinPrice != undefined & this.newRow.MinPrice != '') {
                    this.newRow.MinPrice = this.newRow.MinPrice.replace(',', '')
                }
                if (this.newRow.MaxPrice != undefined & this.newRow.MaxPrice != '') {
                    this.newRow.MaxPrice = this.newRow.MaxPrice.replace(',', '')
                }
                if (this.newRow.Price != undefined & this.newRow.Price != '') {
                    this.newRow.Price = this.newRow.Price.replace(',', '')
                }

                let DataaxiosDepUser = {
                    Action: 'PriceList',
                    Method: 'POST',
                    ArryfildValue: this.newRow,
                }
                console.log("newRow.IsOptional", DataaxiosDepUser);
                this.$PostData(DataaxiosDepUser).then((res) => {
                    if (res.isSuccess) {
                        this.$emit("addRowResult", res.isSuccess)
                        this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
                    } else {

                        this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 5000)

                    }
                }).catch((err) => {
                    this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                    console.error(err)
                })


            }
        },

        vlidForm() {

            let haveFunc = false
            if(this.newRow.Func != undefined){
                if(this.newRow.Func != ''){
                    haveFunc = true
                }
            }
            
            if(this.newRow.FixPrice & this.newRow.Main){
                this.$mySweetDefaultTost('عملیات ناموفق', 'آیتم نمیتواند هم قیمت ثابت باشد هم اصلی', 'error', 5000)
                return false
            }

            if((this.newRow.FixPrice || this.newRow.Main) & haveFunc){
                this.$mySweetDefaultTost('عملیات ناموفق', 'آیتم نمیتواند هم فرمول داشته باشد هم آیتم اصلی یا قیمت ثابت باشد', 'error', 5000)
                return false
            }


            return true
        },

        GetResulTblProductsId(data) {
            if (data.id != null) {
                this.newRow.TblProductId = data.id
            }
        }
    }
}
</script>

<style scoped>
.checkbox {
    height: 20px;
}
</style>